import { Component, DestroyRef, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { WaitModalComponent } from '../modals/wait-modal/wait-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateTime } from 'luxon';
import { PostUploadReturn } from '../../classes/post-upload-return';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-post-processing',
    templateUrl: './post-processing.component.html',
    imports: [
        MatCardModule,
        MatInputModule,
        MatDividerModule,
        MatButtonModule
    ]
})
export class PostProcessingComponent {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly errorSvc = inject(ErrorService);
    protected readonly matDialog = inject(MatDialog);
    selectedFile: File = null;
    fileTypeInvalid: boolean = false;
    report: PostUploadReturn;

    download() {
        let wait = this.matDialog.open(WaitModalComponent);

        this.appSvc.CompletedApplicationsReport().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                wait.close();
                this.saveBlobToFile(res.body, 'CompletedApplications_' + DateTime.now().toFormat('MMM_d_y'));
            }, error: error => {
                wait.close();
                this.errorSvc.HandleServiceError(error);
            }
        });
    }

    saveBlobToFile(blob: Blob, fileName: string): void {
        //setup temporary in-memory URL and html tag
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);

        //programattically click on tag for user
        anchor.click();

        //delete tag and URL
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(url);
    }

    selectFile(e: Event) {
        let input = e.target as HTMLInputElement;
        let file = input.files[0];

        if (file.type.toLowerCase() !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            this.fileTypeInvalid = true;
            return;
        }

        this.fileTypeInvalid = false;
        this.selectedFile = file;
    }

    upload() {
        let wait = this.matDialog.open(WaitModalComponent);
        const dto = new FormData();
        dto.append('file', this.selectedFile, this.selectedFile.name);

        this.appSvc.UploadPostSpreadsheet(dto).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.snackBarSvc.success('Info Uploaded Successfully', 5000);
                this.report = res;
                wait.close();
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
                wait.close();
            }
        });
    }
}
